// Import your component classes. For example:
import { AppHomeComponent } from './components/app-home/app-home.component';

// Import your component classes. For example:
import { C2Component } from './components/c2/c2.component';

// Import the AdminComponent
import { AdminComponent } from './components/admin/admin.component';

// Map the component IDs to the actual component classes.
export const COMPONENT_MAPPING: { [key: string]: any } = {
  'c2': C2Component,
  'admin': AdminComponent,
  'app-home': AppHomeComponent,
  // Add mappings for other components mentioned in roleConfig.json
  'c4': C2Component,  // Temporarily using C2Component for 'c4'
  'c5': C2Component,  // Temporarily using C2Component for 'c5'
  'c8': C2Component,  // Temporarily using C2Component for 'c8'
  'c9': C2Component,  // Temporarily using C2Component for 'c9'
  'c10': C2Component  // Temporarily using C2Component for 'c10'
};
